import styled from 'styled-components';

export const WrapLabel = styled.div`
&&& {
  .ant-form-item-label {
    margin-bottom: 10px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {  
    &&& {
      .ant-form-item-label{
        padding: 0;
      }
    }
  }
`
export const LabelWrapper = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: 0.6px;
  color: ${props => props.theme.fontColors.thead};
  font-weight: ${props => props.theme.fontWeight.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const InputWrapper = styled.div`
input,
.ant-select-selection--single {
  height: 40px;
}
.ant-input {
  border: solid 1px ${props => props.theme.border.pill};
  border-radius: 0;
}
`;

export const InputMargin = styled.div`
.ant-form-item {
  margin-bottom: ${props => props.marginBottom ? props.marginBottom : '40px'};
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .ant-form-item {
    margin-bottom: 30px;
    }
  }
`

